import { Api } from "./Api";

export const getTemplateList = async (search: string,sortOrder: string,statusFilter: string,page = 1,
  limit = 10) => {
  try {
    let url = `/templates`;
    const params = [];
    if (search.trim() !== "") {
      params.push(`title=${encodeURIComponent(search.trim())}`);
    }
    if (sortOrder !== "all") {
      params.push(`usecase=${sortOrder}`);
    }
    
    if (statusFilter !== "all") {
      params.push(`status=${statusFilter}`);
    }
    
    if (params.length > 0) {
      url += "?" + params.join("&");
    }
    const response = await Api.get(url,{
      params: {
          page,
          limit,
      }
  });
    if (response.data && response.data.templates) {
      return {
        templates: response.data.templates || [],
        totalTemplates: response.data.totalTemplates || 0,
        success: response.data.success,
        count: response.data.templates.length,
        totalPage:response.data.totalPages
      };
    } else {
      console.error("Failed to fetch templates: No data found");
      return { templates: [], totalTemplates: 0, success: false };
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 404) {
        console.warn("No templates found (404). Returning empty array.");
        return { templates: [], totalTemplates: 0, success: false };
      } else {
        console.error("Error fetching templates:", error.response.data.message);
        return { error: error.response.data.message, templates: [], totalTemplates: 0, success: false };
      }
    } else {
      console.error("Error fetching templates:", error.message);
      return { error: "An error occurred while trying to fetch templates", templates: [], totalTemplates: 0, success: false };
    }
  }
};

   export const addTemplateList = async (title: string,usecase: string,description: string,status: any) => {
      try {
        const response = await Api.post(
          `/templates`,
          { title,usecase,description,status },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        return response.data;
      } catch (error: any) {
        if (error.response) {
          console.error('Error sending OTP:', error.response.data.message);
          return { error: error.response.data.message };
        } else {
          console.error('Error sending OTP:', error.message);
          return { error: 'An error occurred while sending OTP.' };
        }
      }
    };
    export const EditTemplateList = async (id: any,title: string,usecase: string,description: string,html: string,css: string,status: any) => {
      try {
        const response = await Api.put(
          `/templates/${id}`,
          { title,usecase,description,html,css,status  },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        return response.data;
      } catch (error: any) {
        if (error.response) {
          console.error('An Error Occur while updating templates:', error.response.data.message);
          return { error: error.response.data.message };
        } else {
          console.error('An Error Occur while updating templates:', error.message);
          return { error: 'An Error Occur while updating templates.' };
        }
      }
    };
    export const ArchiveTemplate = async (id: any,status: any) => {
      try {
        const response = await Api.patch(
          `/templates/${id}/status`,
          { status: 2 },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        return response.data;
      } catch (error: any) {
        if (error.response) {
          console.error('Getting error:', error.response.data.message);
          return { error: error.response.data.message };
        } else {
          console.error('Getting error:', error.message);
          return { error: 'An error occurred while archive template.' };
        }
      }
    };